<template>
  <div>

    <div class="container">
        <div class="row">
            <div class="col-1"></div>
            <div class="col-22">
                
              <div class="row">&nbsp;</div>

                <div  v-if="!this.isError">
                    <div class="row"><strong>{{this.customer.FirstName}} {{this.customer.LastName}}</strong></div>
                    <div class="row titleMenuBasket">{{this.customer.Email}}  {{this.customer.Phone}}</div>
                    <div class="row">&nbsp;</div>
                    <div class="row">&nbsp;</div>
                    <div class="row product-btn" >
                      <a @click="createAppoint" style="background-color: #ff0000;color:#fff"><i class="ion-bag" ></i>Maak afspraak voor deze klant</a>
                    </div>
                </div>
                <div else>
                    {{this.errormsg}}
                </div>
           

              <div class="row">&nbsp;</div>
              <div class="row">&nbsp;</div>
             
            </div>
            <div class="col-1"></div>
        </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import myHttpApi from "../api/myhttpapi";
  import {
    SPINNER_SHOW,
    SPINNER_HIDE
  } from '../store/mutation-types'

  export default {
    components: {
    },
     data () {
      return {
        errormsg : '',
        isError : false,
        customer : {},
        isShowNewApp : false,
        id : this.$route.params['id']
      }
    },
    mounted () {
      this.loadMyCustomerStore ();
    },
    computed: {
      getColorApp () {
           return Vue.$storeSettings.ColorApp;
       }
    },
    methods: {
      createAppoint () {
         this.$router.push('/');
      },
      loadMyCustomerStore () {
          this.$store.commit(SPINNER_SHOW);
          this.errormsg = "";
          this.customer = {};
          this.isError = false;

          Vue.$storeCustomer = undefined;
          const searchRec = {Token: this.id }
          myHttpApi.post( 'Account/GetStoreCustomer', searchRec)
              .then(response => {
                 if (response.data.ResultCode == 0)
                 {
                    this.customer = response.data;
                    Vue.$storeCustomer = response.data;    
                 }
                 else
                 {
                    this.isError = true;
                    this.customer = {};
                    Vue.$storeCustomer = undefined;
                    this.errormsg = response.data.ErrorMsg;
                 }
                 this.$store.commit(SPINNER_HIDE);
              })
              .catch(error => {
                this.isError = true;
                this.customer = {};
                this.errormsg = error;
                Vue.$storeCustomer = undefined;
                this.$store.commit(SPINNER_HIDE);
          });
      },
    }
  }
</script>
<style>
  .products {
    background: #F7F8FB;
    padding: 30px 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/StoreAppoint.vue